/**
 * Conversão entre o formato de cor do Fastfood (Delphi TColor, `$00BBGGRR`) e o formato web
 * (`#RRGGBB`), único aceito por `<input type="color">`.
 *
 * A leitura tolera os dois formatos porque o InfoCloud gravou `#RRGGBB` nessa coluna enquanto não
 * existia conversão. A gravação normaliza sempre para o formato do Fastfood.
 */

const HEXADECIMAL = /^[0-9a-f]+$/i

// Constantes de cor do Delphi (VCL) que o Fastfood grava pelo nome. Cores de sistema (clBtnFace,
// clWindow...) dependem do tema do Windows e não têm valor fixo: ficam sem conversão.
const CORES_DELPHI = {
  clblack: '#000000', clmaroon: '#800000', clgreen: '#008000', clolive: '#808000',
  clnavy: '#000080', clpurple: '#800080', clteal: '#008080', clgray: '#808080',
  clsilver: '#C0C0C0', clred: '#FF0000', cllime: '#00FF00', clyellow: '#FFFF00',
  clblue: '#0000FF', clfuchsia: '#FF00FF', claqua: '#00FFFF', clwhite: '#FFFFFF',
  clmoneygreen: '#C0DCC0', clskyblue: '#A6CAF0', clcream: '#FFFBF0', clmedgray: '#A0A0A4',
  clltgray: '#C0C0C0', cldkgray: '#808080'
}

const somenteHexadecimal = (valor) => `${valor}`.trim().replace(/^[#$]/, '')

/** `$00BBGGRR`, `#RRGGBB` ou nome Delphi (`clRed`) → `#RRGGBB`. Valor desconhecido ou vazio retorna string vazia. */
export const paraCorWeb = (valor) => {
  if (!valor) return ''

  const original = `${valor}`.trim()
  const corNomeada = CORES_DELPHI[original.toLowerCase()]
  if (corNomeada) return corNomeada
  const hexadecimal = somenteHexadecimal(original)
  if (!HEXADECIMAL.test(hexadecimal)) return ''

  if (original.startsWith('#') && hexadecimal.length === 6) {
    return `#${hexadecimal.toUpperCase()}`
  }

  // Delphi guarda o inverso do web: os dois últimos pares são verde e vermelho.
  const bgr = hexadecimal.padStart(8, '0').slice(-6)
  if (bgr.length !== 6) return ''

  const azul = bgr.substring(0, 2)
  const verde = bgr.substring(2, 4)
  const vermelho = bgr.substring(4, 6)

  return `#${vermelho}${verde}${azul}`.toUpperCase()
}

/** `#RRGGBB` → `$00BBGGRR`. Valor inválido ou vazio retorna null, para não gravar lixo na coluna. */
export const paraCorFastfood = (valorWeb) => {
  if (!valorWeb) return null

  const hexadecimal = somenteHexadecimal(valorWeb)
  if (hexadecimal.length !== 6 || !HEXADECIMAL.test(hexadecimal)) return null

  const vermelho = hexadecimal.substring(0, 2)
  const verde = hexadecimal.substring(2, 4)
  const azul = hexadecimal.substring(4, 6)

  return `$00${azul}${verde}${vermelho}`.toUpperCase()
}
